
<script setup>
import { onMounted, onBeforeUnmount } from 'vue'
import { ElNotification } from 'element-plus'
import 'element-plus/es/components/notification/style/css'

let eventHandler = null

// 根据类型获取对应的通知样式
const getNotificationType = (type) => {
  const typeMap = {
    'success': 'success',
    'error': 'error',
    'warning': 'warning',
    'info': 'info',
    'text': 'info' // 文本消息默认使用info样式
  }
  return typeMap[type] || 'info'
}

const showNotification = (payload) => {
  console.log('payload', payload);
  // 确保payload有必要的字段
  const notification = {
    type: payload.type || '通知',
    content: payload.content || '收到一条新消息',
    timestamp: payload.timestamp || Date.now()
  }
  
  // 使用Element Plus的Notification组件
  ElNotification({
    title: notification.type,
    message: notification.content,
    type: getNotificationType(notification.type),
    duration: 30000, // 30秒后自动关闭
    showClose: true // 显示关闭按钮
  })
}

onMounted(() => {
  eventHandler = (e) => {
    showNotification(e.detail)
  }
  window.addEventListener('global-notification', eventHandler)
})

onBeforeUnmount(() => {
  if (eventHandler) {
    window.removeEventListener('global-notification', eventHandler)
  }
  // 关闭所有通知
  ElNotification.closeAll()
})
</script>